var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 13",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.232.029.928 3.419a1.295 1.295 0 0 0 .008 2.486l4.724 1.35 1.35 4.727c.157.551.667.933 1.24.933s1.083-.378 1.248-.927L12.904.636c.086-.605-.379-.695-.672-.607ZM10.668 1.54l-4.75 4.75-4.709-1.345A.286.286 0 0 1 1 4.665c0-.135.085-.25.215-.289l9.453-2.836Zm.707.707-2.836 9.454a.297.297 0 0 1-.289.214.284.284 0 0 1-.277-.209L6.625 6.997Z"
})));
export default SvgShare;